<template>
  <div style="margin-top: 50px; padding: 20px">
    {{ $route.query.text }}
  </div>
</template>

<script>
export default {
  name: "sms",
  data: function () {
    return {
    };
  },
};
</script>
